<template>
  <billing-report-panel
    report-key="receivables-aging"
    route="/reports/billing-receivables-aging"
    file-name="contas-a-receber-de-convenio.xlsx"
    period-label="Período de emissão do título"
    :columns="columns"
    :default-days="180"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Faixa de vencimento',
        'Convênio e plano',
        'Lote',
        'Competência',
        'Emissão',
        'Vencimento',
        'Dias',
        'Valor em aberto',
        'Situação do título',
        'Subtotal por faixa',
      ],
    };
  },
};
</script>
